(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  document.querySelectorAll('.footer-block--menu').forEach((menu) => {
    const heading = menu.querySelector('.footer-block__heading');
    const content = menu.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    const toggleMenu = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const isOpen = menu.classList.toggle('is-open');
      heading.setAttribute('aria-expanded', isOpen.toString());
    };

    heading.addEventListener('click', toggleMenu);
    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleMenu();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.sticky != 'true') return;
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(max-width: 989px)');
    const shopMenu = document.querySelector('#shopify-section-header .header__shop-menu');
    const trigger = shopMenu?.querySelector('.header__shop-all');

    if (!shopMenu || !trigger) return;

    const closeShopMenu = () => {
      shopMenu.classList.remove('is-mobile-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (event) => {
      if (!mediaQuery.matches) return;

      event.preventDefault();
      const willOpen = !shopMenu.classList.contains('is-mobile-open');
      closeShopMenu();

      if (willOpen) {
        shopMenu.classList.add('is-mobile-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        trigger.blur();
      }
    });

    document.addEventListener('click', (event) => {
      if (!shopMenu.contains(event.target)) closeShopMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeShopMenu();
    });

    mediaQuery.addEventListener('change', closeShopMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const initialiseRows = () => {
      document.querySelectorAll('.yrp-bestsellers__mobile-row').forEach((row) => {
        if (row.dataset.yrpAutoScroll === 'true') return;
        row.dataset.yrpAutoScroll = 'true';

        let direction = 1;
        let paused = false;
        let resumeTimer;
        let previousTime = performance.now();
        const speed = 45;

        const pauseTemporarily = () => {
          paused = true;
          window.clearTimeout(resumeTimer);
          resumeTimer = window.setTimeout(() => {
            paused = false;
            previousTime = performance.now();
          }, 2200);
        };

        row.addEventListener('pointerdown', pauseTemporarily, { passive: true });
        row.addEventListener('touchstart', pauseTemporarily, { passive: true });
        row.addEventListener('wheel', pauseTemporarily, { passive: true });
        row.addEventListener('focusin', () => { paused = true; });
        row.addEventListener('focusout', () => {
          paused = false;
          previousTime = performance.now();
        });

        const move = (time) => {
          const elapsed = Math.min((time - previousTime) / 1000, .05);
          previousTime = time;
          const maxScroll = row.scrollWidth - row.clientWidth;

          if (!paused && maxScroll > 1) {
            row.scrollLeft += direction * speed * elapsed;

            if (row.scrollLeft >= maxScroll - 1) {
              row.scrollLeft = maxScroll;
              direction = -1;
            } else if (row.scrollLeft <= 1) {
              row.scrollLeft = 0;
              direction = 1;
            }
          }

          window.requestAnimationFrame(move);
        };

        window.requestAnimationFrame(move);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseRows, { once: true });
    } else {
      initialiseRows();
    }

    document.addEventListener('shopify:section:load', initialiseRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-yrp-collection-back]');
    if (!backLink || !document.referrer || window.history.length < 2) return;
    event.preventDefault();
    window.history.back();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('yrp-product-recommendations')) {
    customElements.define('yrp-product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.animationFrame = null;
        this.resumeTimer = null;
        this.lastFrameTime = null;
        this.loopPoint = 0;
        this.autoPosition = 0;

        this.addEventListener('pointerdown', () => this.pauseAutoplay());
        this.addEventListener('wheel', () => this.pauseAutoplay(), { passive: true });
        this.addEventListener('focusin', () => this.pauseAutoplay());

        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('yrp-product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                this.prepareContinuousLoop();
                this.startAutoplay();
              }
            })
            .catch(() => {});
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(this);
        this.prepareContinuousLoop();
        this.startAutoplay();
      }

      prepareContinuousLoop() {
        const slider = this.querySelector('.product-recommendations__slider');
        if (!slider || slider.dataset.loopReady === 'true') return;

        const originalCards = Array.from(slider.children);
        if (originalCards.length < 2) return;

        const clones = originalCards.map((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          slider.appendChild(clone);
          return clone;
        });

        this.loopPoint = clones[0].offsetLeft - originalCards[0].offsetLeft;
        slider.dataset.loopReady = 'true';
      }

      startAutoplay() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        window.cancelAnimationFrame(this.animationFrame);
        this.lastFrameTime = null;
        const slider = this.querySelector('.product-recommendations__slider');
        this.autoPosition = slider ? slider.scrollLeft : 0;
        this.animationFrame = window.requestAnimationFrame((time) => this.advanceSlider(time));
      }

      pauseAutoplay() {
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resumeTimer);
        this.resumeTimer = window.setTimeout(() => this.startAutoplay(), 9000);
      }

      advanceSlider(time) {
        const slider = this.querySelector('.product-recommendations__slider');
        if (!slider || !this.loopPoint) return;

        if (this.lastFrameTime !== null) {
          const elapsed = Math.min(time - this.lastFrameTime, 50);
          this.autoPosition += elapsed * 0.018;
          if (this.autoPosition >= this.loopPoint) this.autoPosition -= this.loopPoint;
          slider.scrollLeft = this.autoPosition;
        }

        this.lastFrameTime = time;
        this.animationFrame = window.requestAnimationFrame((nextTime) => this.advanceSlider(nextTime));
      }

      disconnectedCallback() {
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resumeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const maxMovement = 12;
    let startPoint = null;

    document.addEventListener('pointerdown', (event) => {
      const section = event.target.closest('[data-reviews-gallery-url]');
      if (!section) return;
      startPoint = {
        section,
        x: event.clientX,
        y: event.clientY,
        pointerId: event.pointerId
      };
    }, true);

    document.addEventListener('pointerup', (event) => {
      if (!startPoint || startPoint.pointerId !== event.pointerId) return;
      const movementX = Math.abs(event.clientX - startPoint.x);
      const movementY = Math.abs(event.clientY - startPoint.y);
      const section = startPoint.section;
      startPoint = null;
      if (movementX > maxMovement || movementY > maxMovement) return;
      window.location.assign(section.dataset.reviewsGalleryUrl);
    }, true);

    document.addEventListener('pointercancel', () => {
      startPoint = null;
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
